import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
    score: {
        // marginTop: theme.spacing(0.5)
    }
}));

const CountText = ({count, headingText, countPostText = "sites found"}) => {
    const classes =  useStyles()
  return (
    <div style={count ? {} : { visibility: "hidden" }}>
      <Typography variant="h6" component="span">
        {headingText}{" "}
      </Typography>
      <Typography
        variant="subtitle2"
        component="span"     
        className={classes.score}
      >
        ({count + " " + countPostText})
      </Typography>
    </div>
  );
};

export default CountText;
